import {
  CellApiModule,
  CellStyleModule,
  ClientSideRowModelApiModule,
  ClientSideRowModelModule,
  ColumnApiModule,
  ColumnAutoSizeModule,
  ColumnHoverModule,
  CustomFilterModule,
  DateFilterModule,
  DragAndDropModule,
  EventApiModule,
  ExternalFilterModule,
  GridStateModule,
  InfiniteRowModelModule,
  LocaleModule,
  ModuleRegistry,
  NumberFilterModule,
  RenderApiModule,
  RowApiModule,
  RowAutoHeightModule,
  RowDragModule,
  RowSelectionModule,
  RowStyleModule,
  ScrollApiModule,
  SelectEditorModule,
  TextEditorModule,
  TextFilterModule,
  TooltipModule,
  ValidationModule,
} from 'ag-grid-community';

const terraAgGridModules = [
  ClientSideRowModelModule,
  ClientSideRowModelApiModule,
  InfiniteRowModelModule,
  RowSelectionModule,
  RowDragModule,
  DragAndDropModule,
  TextFilterModule,
  NumberFilterModule,
  DateFilterModule,
  CustomFilterModule,
  ExternalFilterModule,
  TextEditorModule,
  SelectEditorModule,
  TooltipModule,
  CellStyleModule,
  CellApiModule,
  ColumnAutoSizeModule,
  ColumnApiModule,
  ColumnHoverModule,
  RowApiModule,
  RowAutoHeightModule,
  RowStyleModule,
  ScrollApiModule,
  RenderApiModule,
  EventApiModule,
  GridStateModule,
  LocaleModule,
  ...(process.env.NODE_ENV === 'production' ? [] : [ValidationModule]),
];

export const registerTerraAgGridModules = (): void => {
  ModuleRegistry.registerModules(terraAgGridModules);
};
